import React from 'react'

export default function Footer() {
  return (
          <a href="https://github.com/kiron0/analog_clock" target="_blank" rel='noreferrer' className="clock__logo">Toufiq Hasan Kiron</a>
  )
}
